import { Injectable } from '@angular/core';
import * as componentActions from '@catdetails/actions/userdata-generation';
import { Store } from '@ngrx/store';

/**
 * Injectable
 */
@Injectable()
export class UserdataGenerationService {

  /**
   * Creates an instance of userdata generation service.
   * @param store
   */
  constructor(private store: Store<any>) {
  }

  /**
   * Sets active
   */
  setActive() {
    this.store.dispatch({
      type: componentActions.PROJECT_DETAILS_USERDATA_GENERATION_ACTIVATE,
    },
    );
  }

  /**
   * Sets inactive
   */
  setInactive() {
    this.store.dispatch({
      type: componentActions.PROJECT_DETAILS_USERDATA_GENERATION_DEACTIVATE,
    },
    );
  }
}



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_master@2/app/Resources/Public/src/app/modules/models/userdata-generation/services/userdata-generation.service.ts